import React, { useEffect, useState } from "react";
import { Inbox, Paperclip, ChevronDown } from "lucide-react";
import { toast } from "sonner";
import { api, fileUrl } from "@/lib/api";

const STATUS = ["new", "contacted", "quoted", "won", "lost"];
const badge = { new: "bg-blue-100 text-blue-700", contacted: "bg-amber-100 text-amber-700", quoted: "bg-purple-100 text-purple-700", won: "bg-green-100 text-green-700", lost: "bg-red-100 text-red-700" };

export default function AdminLeads() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(null);

  const load = () => api.get("/leads").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const setStatus = async (id, status) => {
    try { await api.put(`/leads/${id}`, { status }); setItems((p) => p.map((l) => l.id === id ? { ...l, status } : l)); toast.success("Updated"); }
    catch { toast.error("Failed"); }
  };

  return (
    <div>
      <div className="mb-8"><h1 className="font-display font-extrabold text-3xl tracking-tight">Leads</h1><p className="text-muted-foreground text-sm mt-1">{items.length} inbound inquiries</p></div>

      {items.length === 0 ? (
        <div className="border border-border bg-card py-20 text-center text-muted-foreground"><Inbox className="mx-auto mb-3" /> No leads yet. Submissions from the public contact form appear here.</div>
      ) : (
        <div className="space-y-3">
          {items.map((l) => (
            <div key={l.id} className="border border-border bg-card" data-testid={`lead-${l.id}`}>
              <button onClick={() => setOpen(open === l.id ? null : l.id)} className="w-full flex items-center gap-4 px-5 py-4 text-left">
                <div className="flex-1 min-w-0">
                  <div className="font-medium">{l.name} {l.company && <span className="text-muted-foreground">· {l.company}</span>}</div>
                  <div className="text-xs text-muted-foreground mt-0.5">{l.project_type || "—"} · {l.project_location || "—"} · {l.budget || "—"}</div>
                </div>
                <span className={`text-[10px] uppercase tracking-wide px-2.5 py-1 ${badge[l.status] || badge.new}`}>{l.status}</span>
                <ChevronDown size={16} className={`text-muted-foreground transition-transform ${open === l.id ? "rotate-180" : ""}`} />
              </button>
              {open === l.id && (
                <div className="px-5 pb-5 border-t border-border pt-4 space-y-4">
                  <div className="grid sm:grid-cols-2 gap-3 text-sm">
                    <div><span className="text-muted-foreground">Email: </span>{l.email || "—"}</div>
                    <div><span className="text-muted-foreground">Phone: </span>{l.phone || "—"}</div>
                  </div>
                  {l.description && <p className="text-sm bg-secondary/50 p-4">{l.description}</p>}
                  {l.files?.length > 0 && (
                    <div className="flex flex-wrap gap-2">
                      {l.files.map((f, i) => <a key={i} href={fileUrl(f)} target="_blank" rel="noreferrer" className="flex items-center gap-1.5 text-sm border border-border px-3 py-1.5 hover:bg-secondary transition-colors"><Paperclip size={13} /> Attachment {i + 1}</a>)}
                    </div>
                  )}
                  <div className="flex items-center gap-2">
                    <span className="text-xs uppercase tracking-wide text-muted-foreground">Status:</span>
                    {STATUS.map((s) => <button key={s} onClick={() => setStatus(l.id, s)} className={`text-xs px-3 py-1.5 border transition-colors ${l.status === s ? "bg-foreground text-background border-foreground" : "border-border hover:bg-secondary"}`}>{s}</button>)}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
